var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryInlineAdLib(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H31.5V39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15C15 14.4477 15.4477 14 16 14C16.5523 14 17 14.4477 17 15V17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H17V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V19H13C12.4477 19 12 18.5523 12 18C12 17.4477 12.4477 17 13 17H15V15ZM13.5 24.75C13.5 25.4404 12.9404 26 12.25 26C11.5596 26 11 25.4404 11 24.75C11 24.0596 11.5596 23.5 12.25 23.5C12.9404 23.5 13.5 24.0596 13.5 24.75ZM17.25 24.75C17.25 25.4404 16.6904 26 16 26C15.3096 26 14.75 25.4404 14.75 24.75C14.75 24.0596 15.3096 23.5 16 23.5C16.6904 23.5 17.25 24.0596 17.25 24.75ZM19.75 26C20.4404 26 21 25.4404 21 24.75C21 24.0596 20.4404 23.5 19.75 23.5C19.0596 23.5 18.5 24.0596 18.5 24.75C18.5 25.4404 19.0596 26 19.75 26Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryInlineAdLib);
export default __webpack_public_path__ + "static/media/Primary_Inline_AdLib.429edb754e72527f840c1723a0b0c744.svg";
export { ForwardRef as ReactComponent };